import React from "react";
import "../styles/ProgressBar.css";

const ProgressBar = ({ step, totalSteps }) => {
  const progress = (step / totalSteps) * 100;

  return (
    <div className="progress-bar-container">
      <div className="progress-bar" style={{ width: `${progress}%` }}></div>
      <div className="progress-markers">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div
            key={i}
            className={`marker ${step >= i + 1 ? "active" : ""}`}
            style={{ left: `${(i / (totalSteps - 1)) * 100}%` }}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
